import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'jsonParse'
})
export class JsonParsePipe implements PipeTransform {

  transform(value: string, args?: any): any {
    if (value){
      try {
        return JSON.parse(value);
      } catch(e) {
        console.error(e);
        return null
      }
    } else {
          return null;
      }
  } 

}
